module.exports = {"Eastern":"America/New_York","Central":"America/Chicago","Mountain":"America/Denver","Mountain no DST":"America/Phoenix","Pacific":"America/Los_Angeles","Alaska":"America/Anchorage","Hawaii":"America/Adak","Hawaii no DST":"Pacific/Honolulu"}


//////////////////
// WEBPACK FOOTER
// ./src/sc/ui/components/data/timezones.json
// module id = 429
// module chunks = 0